














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Row extends Vue {
  @Prop({ default: 'var(--gutter)' })
  public readonly gutter!: number;

  @Prop({ default: 'center' })
  public readonly verticalAlign!: string;

  @Prop({ default: 'space-between' })
  public readonly horizontalAlign!: string;

  @Prop({ default: 'wrap' })
  public readonly wrap!: string;
}
